module.exports = __webpack_public_path__ + "sourcesanspro-bold.1146f3f229f5a3d3c711.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/sourcesanspro/sourcesanspro-bold.woff
// module id = ../../../../../src/fonts/sourcesanspro/sourcesanspro-bold.woff
// module chunks = 2